// extracted by mini-css-extract-plugin
export default {"cancelPlan":"ff2f7caab4ba","planDetails":"a50f0deea33c","paymentDetails":"a7ead3075c2e","planActions":"b147e1343b80","changePlanText":"bd666592ae68"};